import { render, staticRenderFns } from "./login-prompt.vue?vue&type=template&id=1ddb13d6&"
import script from "./login-prompt.vue?vue&type=script&lang=js&"
export * from "./login-prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports